import { Component } from '@angular/core';

@Component({
    selector: 'app-appointment-booking-confirmation',
    templateUrl: './appointment-booking-confirmation.component.html',
    styleUrls: ['./appointment-booking-confirmation.component.scss'],
    standalone: false
})
export class AppointmentBookingConfirmationComponent {

}
